import React, { useCallback, useMemo } from 'react';
import { mdiContentSaveEditOutline } from '@mdi/js';

import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import ProfilePage54origins from '../54origins/components/ProfilePage54origins';
import ProfileEditFormComponent from './ProfileEditFormComponent';

import { ProfileConstants } from '../profile/constants';

import useCustomState from '../hooks/useCustomState';
import AntButtonWithMDI from './AntButtonWithMDI';
import { capitalizeAndTranslateMsg } from '../mainUtils';
import { getMeIsRootOrAdmin } from '../profile/selectors';

const profileTypes = [
  ProfileConstants.GET_PROFILE_INFO_REQUEST,
  ProfileConstants.GET_PROFILE_INFO_SUCCESS,
  ProfileConstants.GET_PROFILE_INFO_FAILURE,
];

function AuthProfileWrapper() {
  const {
    toggle,
    updateTime,
    setToggle,
    changeState,
  } = useCustomState();

  const meIsRootOrAdmin = useSelector(getMeIsRootOrAdmin);

  const updateActorCallback = useCallback(() => {
    changeState({ updateTime: new Date().getTime() });
  }, []);

  const editBtn = meIsRootOrAdmin ? (
    <AntButtonWithMDI
      type="primary"
      className="ml-auto"
      onClick={setToggle}
      iconClassName="mb-1 mr-1"
      pathForMdi={mdiContentSaveEditOutline}
      label={capitalizeAndTranslateMsg('54origins.verb.edit', 'Edit')}
    />
  ) : (
    <Tooltip title="Only for Root or Admin">
      <span className="ml-auto">
        <AntButtonWithMDI
          disabled
          type="primary"
          className="ml-auto"
          onClick={setToggle}
          iconClassName="mb-1 mr-1"
          pathForMdi={mdiContentSaveEditOutline}
          label={capitalizeAndTranslateMsg('54origins.verb.edit', 'Edit')}
        />
      </span>
    </Tooltip>
  );

  const editComponent = useMemo(() => toggle && (
    <ProfileEditFormComponent
      setToggle={setToggle}
      updateActorCallback={updateActorCallback}
    />
  ), [toggle]);

  return (
    <ProfilePage54origins
      updateFromOuterComponent={updateTime}
      typesForRequest={profileTypes}
      editBtn={editBtn}
      editComponent={editComponent}

    />
  );
}

export default AuthProfileWrapper;
